<!-- Tool selection lives in the account rail (indented under Admin). This
     host just renders the tool matching the ?tab query param / selectedTab. -->
<div class="admin-options mt-4 mb-3 d-flex align-items-center justify-content-center gap-3 flex-wrap" *ngIf="loaded && showTabBar">
  <button *ngFor="let t of releaseTabs" class="btn"
          [ngClass]="{'btn-primary': selectedTab === t.id, 'btn-outline-primary': selectedTab !== t.id}"
          (click)="SetTab(t.id)">{{ t.label }}</button>
</div>
<div class="admin-content" *ngIf="loaded">
  <pla-admin-founder-cockpit *ngIf="selectedTab === 'founder-cockpit'"></pla-admin-founder-cockpit>
  <pla-admin-yearly-top-sales *ngIf="selectedTab === 'yearly-top-sales'"></pla-admin-yearly-top-sales>
  <pla-admin-sold-search *ngIf="selectedTab === 'sold-search'"></pla-admin-sold-search>
  <pla-admin-multiple-sales *ngIf="selectedTab === 'multiple-sales'"></pla-admin-multiple-sales>
  <pla-admin-comparables *ngIf="selectedTab === 'comparables'"></pla-admin-comparables>
  <pla-admin-valuation-lab *ngIf="selectedTab === 'valuation-lab' && editorialEnabled"></pla-admin-valuation-lab>
  <pla-auction-admin *ngIf="selectedTab === 'auctions'"></pla-auction-admin>
  <pla-admin-blog-create *ngIf="selectedTab === 'blog'"></pla-admin-blog-create>
  <pla-admin-blog-config *ngIf="selectedTab === 'blog-config'"></pla-admin-blog-config>
  <pla-admin-static-media *ngIf="selectedTab === 'static-media'"></pla-admin-static-media>
  <pla-admin-recently-added *ngIf="selectedTab === 'recently-added'"></pla-admin-recently-added>
  <pla-admin-plate-viewer-toggle *ngIf="selectedTab === 'viewer-config'"></pla-admin-plate-viewer-toggle>
  <pla-admin-gpt *ngIf="selectedTab === 'gpt'"></pla-admin-gpt>
  <pla-admin-wordbank *ngIf="selectedTab === 'wordbank'"></pla-admin-wordbank>
  <pla-admin-users *ngIf="selectedTab === 'users'"></pla-admin-users>
  <pla-admin-dealer-health *ngIf="selectedTab === 'dealer-health'"></pla-admin-dealer-health>
</div>
